import { render } from "./ClientesView.vue?vue&type=template&id=74136798&scoped=true"
import script from "./ClientesView.vue?vue&type=script&lang=js"
export * from "./ClientesView.vue?vue&type=script&lang=js"

import "./ClientesView.vue?vue&type=style&index=0&id=74136798&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74136798"]])

export default __exports__